import { PAGE_DESIGN_WIDTH_IN_PIXEL } from '../../constants/appConstants';
import { TableRowData } from '../../types/dataType';
export const LOG_PAGE_WRAPPER_CLASS_NAME = "log-page-wrapper";
export const NAV_LEFT_CLASS_NAME = "left-menu";
export const NAV_LEFT_MENU_ITEM = "left-menu-item";
export const DEFAULT_BACKGROUND_COLOR_OF_MENU_ITEM = "white";
export const BACKGROUND_COLOR_OF_SELECTED_ITEM = "antiquewhite";
export const PAGE_WRAPPER_CLASS_NAME = "page-wrapper";
export const LOG_TABLE_WRAPPER_CLASS_NAME = "log-table-wrapper";
export const JQL_CODE_CLASSNAME = "jql-code";
export const INCOMPLETE_DOCUMENT_CLASS_NAME = "incomplete-document";
export const OUT_OF_REVIEW_DATE_CELL = "out-of-review-date-cell";

export const HEADER_ITEM_CLASS_NAME = "header-item";
export const SORT_ICON = "sort-icon";
export const DOCUMENT_CODE_COLUMN_INDEX = 1;
export const DOCUMENT_NAME_COLUMN_INDEX = 2;

export const SEARCH_ITEM_BY_JQL_CLASSNAME = "search-item-by-jql";
export const SEARCH_ITEM_BUTTON = "search-item-button";
export const SEARCH_BY_JQL_CODE_TEXT = "Seach by JQL code";
export const INVALID_INPUT_MESSAGE = "JQL Input is invalid"